module.exports = __webpack_public_path__ + "static/media/016.6dc29950.jpg";